<template>
  <div
    class="custom-select-price-dropdown-content"
  >
    <div class="inner">
      <div class="input-wrap input-wrap_first">
        <label class="label">от</label>
        <ui-input
          placeholder=""
          @blur="updateFrom"
          v-model="localFrom"
          numbers
        />
      </div>

      <div class="input-wrap">
        <label class="label">до</label>
        <ui-input
          placeholder=""
          @blur="updateTo"
          v-model="localTo"
          numbers
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getFrom, getTo } from '@/utils/price-input-fix';

export default {
  name: 'custom-select-price-dropdown-content',

  props: {
    options: {
      type: Array,
      default: () => []
    },
    from: {
      type: [String, Number],
      default: '0',
    },
    to: {
      type: [String, Number],
      default: '0',
    },
    min: {
      type: [String, Number],
      default: '0',
    },
    max: {
      type: [String, Number],
      default: '0',
    }
  },

  data() {
    return {
      localFrom: null,
      localTo: null,
    };
  },

  watch:{
    from: {
      handler(from) {
        this.localFrom = from;
      },
      immediate: true,
    },
    to: {
      handler(to) {
        this.localTo = to;
      },
      immediate: true,
    },
  },

  methods: {
    updateFrom() {
      const from = getFrom({from: this.localFrom, to: this.localTo, min: this.min});

      this.localFrom = from;
      this.$emit('update-price', {
        from,
        to: this.localTo,
      });
    },
    updateTo() {
      const to = getTo({from: this.localFrom, to: this.localTo, max: this.max});

      this.localTo = to;
      this.$emit('update-price', {
        from: this.localFrom,
        to,
      });
    },
  },
}
</script>

<style lang="scss">
  .custom-select-price-dropdown-content {
    width: 240px;
    padding: 14px 12px 20px 12px;

    .inner {
      display: flex;
    }

    .ui-input {
      min-height: auto;

      input {
        width: 100%;
      }
    }

    .input-wrap {
      flex: 1;
    }

    .input-wrap:first-child {
      margin-right: 8px;
    }

    .label {
      display: block;
      font-size: 14px;
      color: $gray;
      margin-bottom: 4px;
    }
  }
</style>